import React, { Component } from 'react';
import axios from 'axios'
import UserContext from '../../utils/userContext'
import './blog-bookmark.style.css';
import {
    Link,
} from 'react-router-dom'


export default class BlogBookmark extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            posts: []
        };
    }


    componentDidMount() {
        if (this.context.userData.loggedIn) {
            const self = this
            axios({
                method: 'get',
                url: "https://www.borntodev.com/wp-json/devblog/v1/list/save",
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(function (response) {
                    // console.log(response)
                    self.setState({ posts: response.data })
                })
                .catch(function (response) {
                });
        }

    }


    render() {
        return (
            <div className="blog-bookmark-wrap">
                <Link to={'/list'}>
                <p className="blog-bookmark-head"><i class="far fa-bookmark"></i>🔖 บทความที่บันทึกไว้ </p>
                </Link>
                <div className="blog-bookmark-feed">

                    {this.context.userData.loggedIn ?
                        this.state.posts.length > 0 ?
                            this.state.posts.map((post, i) => <EachBlogBookmark key={i} post={post} index={i} />)
                            :
                            <div className="bookmark-grey">ไม่มีบทความที่บันทึกไว้</div>
                        :
                        <div className="bookmark-grey">คุณยังไม่ได้เข้าสู่ระบบ</div>
                    }
                </div>
            </div>
        )
    }

}


const EachBlogBookmark = ({ post, index }) => {
    var thaiMonth = ["มกราคม", "กุมพาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
    var date = post.readinglistSavedTS;
    if (date !== "") {
        date = (new Date(post.readinglistSavedTS));
        date = date.getDate() + " " + thaiMonth[date.getMonth()] + " " + (543 + date.getFullYear())
    }
    return (
        <div>
            {index < 4 ?
                <div className="bookmark-card">

                    <div className="bookmark-author">
                        <Link to={`/${post.userNicename}/`}>
                            <div className="bookmark-author-image" style={{ backgroundImage: `url(${post.authorImage})` }}>
                            </div>
                        </Link>
                        <Link to={`/${post.userNicename}/`}>
                            <div className="bookmark-author-name">

                                {post.authorName}

                            </div>
                        </Link>
                    </div>
                    <Link to={`/${post.authorLogin}/${post.path}`}>
                        <div className="bookmark-title ellipsis-two-lines">

                            {post.title}

                        </div>
                    </Link>

                    <div className="bookmark-time">
                        {date}
                    </div>


                </div>
                : ""
            }
        </div >
    )
}



// export default BlogBookmark;
